// src/pages/Home.js
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/Hero";
import TrustBanner from "../components/TrustBanner";
import Navbar from "../components/Navbar";
import Features from "../components/Features";
import Comparison from "../components/Comparison";
import Pricing from "../components/Pricing";
import PainPoints from "../components/PainPoints";
import LiveDemoPromo from "../components/LiveDemoPromo";
import ScoutResults from "../components/ScoutResults";
import HowItWorks from "../components/HowItWorks";
import Footer from "../components/Footer";
import CookieBanner from "../components/Cookie";
import FAQ from "./FAQ";

import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

const Home = () => {
  const location = useLocation();

  // 🔌 WebSocket — shared clientId for Hero → LiveDemoPromo progress
  const [clientId] = useState(() => "preview_" + Math.random().toString(36).substring(2, 11));
  const [scoutState, setScoutState] = useState({
    loading: false,
    datasets: [],
    insights: [],
    error: null,
    status: "",
    progress: 0,
  });

  useEffect(() => {
    const wsUrl = (API_URL.replace("http", "ws")) + "/ws?clientId=" + clientId;
    let socket;
    try {
      socket = new WebSocket(wsUrl);
      socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          setScoutState(prev => ({
            ...prev,
            ...(data.status ? { status: data.status } : {}),
            ...(typeof data.progress === "number" ? { progress: data.progress } : {}),
          }));
        } catch (e) { /* ignore */ }
      };
    } catch (e) { /* WS not available */ }
    return () => { if (socket) socket.close(); };
  }, [clientId]);

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const section = document.getElementById(location.state.scrollTo);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
        window.history.replaceState({}, document.title);
      }
    }
  }, [location]);

  return (
    <div>
      <Helmet>
        <title>Comparedly | Social Media Benchmarking & Competitor Analytics</title>
        <meta name="description" content="Stop guessing. Start winning. Compare your social media performance against competitors with Comparedly's AI-powered analytics and benchmarking tools." />
        <meta property="og:title" content="Comparedly | Social Media Benchmarking & Analytics" />
        <meta property="og:description" content="Compare your social media performance against competitors with Comparedly's AI-powered analytics tools." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://comparedly.com/" />
        <meta property="og:image" content="https://comparedly.com/comparedly-logo_200X200.png" />
        <meta property="fb:app_id" content={process.env.REACT_APP_FACEBOOK_APP_ID} />
        <meta property="twitter:image" content="https://comparedly.com/comparedly-logo_200X200.png" />
        <meta property="twitter:card" content="summary_large_image" />
      </Helmet>
      <Navbar />
      <Hero onScoutResult={setScoutState} clientId={clientId} searchProgress={scoutState.progress} />
      <ScoutResults scoutState={scoutState} />
      <TrustBanner />
      <Features />
      <Comparison />
      <PainPoints />
      <LiveDemoPromo />
      <Pricing />
      <HowItWorks />
      <FAQ isStandalonePage={false} />
      <Footer />
      <CookieBanner />
    </div>
  );
};

export default Home;
